module.exports = __webpack_public_path__ + "static/img/3.741d8eb6.jpg";